import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ed9699a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2ed9699a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9699a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\WebProject\\桌面\\JY-SSO\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed9699a')) {
      api.createRecord('2ed9699a', component.options)
    } else {
      api.reload('2ed9699a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ed9699a&scoped=true&", function () {
      api.rerender('2ed9699a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Role/index.vue"
export default component.exports